import { FileProgress } from './FileProgress';

export const DownloadsList = ({ items }) => (
  <>
    {items.map((download) => (
      <FileProgress
        key={download.id}
        downloadedBytes={download.downloadedBytes}
        fileName={download.fileName}
        fileSizeBytes={download.fileSizeBytes}
        failed={download.__FAILED__}
      />
    ))}
  </>
);
